import { render, staticRenderFns } from "./EditBook.vue?vue&type=template&id=30af86c8&"
import script from "./EditBook.vue?vue&type=script&lang=js&"
export * from "./EditBook.vue?vue&type=script&lang=js&"
import style0 from "./EditBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports